import { CONNECTED_CHANNELS_USER_DATA_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { ACCOUNT_SETTINGS_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[CONNECTED_CHANNELS_USER_DATA_MODULE_ID]: {
		moduleType: 'userData',
		userDataType: 'connectedChannels',
		pageContent: {
			userDataTitle: 'Connected Channels',
			buttons: [
				{
					text: 'Connect Twitch',
					platform: 'twitch',
				},
				{
					text: 'Connect YouTube',
					platform: 'youtube',
				},
				{
					text: 'Connect TikTok',
					platform: 'tiktok',
				},
				// {
				// 	text: 'Connect Facebook',
				// 	platform: 'facebook',
				// },
			],
			links: [
				{
					label: 'Go back',
					routeId: ACCOUNT_SETTINGS_ROUTE_ID,
				},
			],
		},
	},
}
